import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { FooterComponent } from './core/footer/footer.component';
import { SidebarComponent } from './core/sidebar/sidebar.component';
import { HeaderComponent } from './core/header/header.component';
import { HttpConfigInterceptor } from './core/interceptors/http-config-interceptor';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { NotifierModule } from 'angular-notifier';
import { customNotifierOptions } from '../app/core/services/config.service';
import { AuthGuard } from './core/services/auth.guard';
import { UploadModalComponent } from './upload-workbench/upload-modal/upload-modal.component';
import { UploadMissedActionDataValidationComponent } from './upload-missed-action-data-validation/upload-missed-action-data-validation.component';
import { UploadWorkbenchHistoryComponent } from './upload-workbench/upload-workbench-history/upload-workbench-history.component';
import { UploadMissedActionDataValidationHistoryComponent } from './upload-missed-action-data-validation-history/upload-missed-action-data-validation-history.component';
import { ReviewCrawledDataListComponent } from './review-crawled-data/review-crawled-data-list/review-crawled-data-list.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { UrlInstancesAndSchedulesListComponent } from './url-instances-and-schedules/url-instances-and-schedules-list/url-instances-and-schedules-list.component';
import { ReviewMissedDataListComponent } from './review-missed-data/review-missed-data-list/review-missed-data-list.component';
import { SyncRcmMasterDataComponent } from './sync-rcm-master-data/sync-rcm-master-data/sync-rcm-master-data.component';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import PerfectScrollbar from 'perfect-scrollbar';
import { MessagesModule } from 'primeng/messages'; 
import { ConfirmDialogModule } from 'primeng/confirmdialog'; 
@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,HeaderComponent,SidebarComponent,UploadMissedActionDataValidationComponent, UploadMissedActionDataValidationHistoryComponent
    ,ReviewCrawledDataListComponent, UrlInstancesAndSchedulesListComponent, ReviewMissedDataListComponent, SyncRcmMasterDataComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    CoreModule,       
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    CollapseModule.forRoot(),
    TimepickerModule.forRoot(),
    TabsModule.forRoot(),
    BsDatepickerModule.forRoot(),
    PopoverModule.forRoot(),
    NotifierModule.withConfig(customNotifierOptions),
    NgSelectModule,ConfirmDialogModule,MessagesModule
  ],
  providers: [{provide:HTTP_INTERCEPTORS,useClass:HttpConfigInterceptor,multi:true},AuthGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }
